import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'relativetime'
})
export class RelativetimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
     // This 'relativetime' pipe used for change time format like seconds, minutes, hours, days ago
    if (!value) {
      return '-';
    }

    const today = moment();
    const time = moment(value);
    const diff = today.diff(time);
    const duration = moment.duration(diff);
    if (duration.years() == 1) {
      return duration.years() + ' year ago';
    } else if (duration.years() > 1) {
      return duration.years() + ' years ago';
    } else if (duration.weeks() == 1) {
      return duration.weeks() + ' week ago';
    } else if (duration.weeks() > 1) {
      return duration.weeks() + ' weeks ago';
    } else if (duration.days() == 1) {
      return duration.days() + ' day ago';
    } else if (duration.days() > 1) {
      return duration.days() + ' days ago';
    } else if (duration.hours() == 1) {
      return duration.hours() + ' hour ago';
    } else if (duration.hours() > 1) {
      return duration.hours() + ' hours ago';
    } else if (duration.minutes() == 1) {
      return duration.minutes() + ' minute ago';
    } else if (duration.minutes() > 1) {
      return duration.minutes() + ' minutes ago';
    } else if (duration.minutes() < 1 && duration.seconds() > 1) {
      return duration.seconds() + ' seconds ago';
    } else if (duration.seconds() < 2) {
      return '1 second ago';
    }
  }

}
